module.exports = __webpack_public_path__ + "img/BlinkArt_Sword9_Red.026d3cc9.png";